/* eslint-disable no-underscore-dangle */
import React, {
  memo,
} from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import PropTypes from 'prop-types';
import { useTablePart } from '../../../../BaseEditor/tablePart/hook';
import TPCommandPanel from '../../../../BaseEditor/tablePart/commandPanels/materialCommandPanel';
import Row from './row';

const defaultRecord = () => ({
  land: { id: '', repr: '' },
  amount: '0',
  isCalculate: true,
});

const options = {
  type: 'field',
  required: false,
  read_only: false,
  label: 'Земельні ділянки',
  child: {
    type: 'nested object',
    required: false,
    read_only: false,
    label: 'Земельні ділянки',
    children: {
      id: {
        type: 'integer',
        required: false,
        read_only: true,
        label: 'ID',
      },
      land: {
        type: 'nested object',
        required: false,
        read_only: true,
        label: 'Земельна ділянка',
        children: {
          id: {
            type: 'integer',
            required: false,
            read_only: true,
            label: 'ID',
          },
          repr: {
            type: 'field',
            required: false,
            read_only: true,
            label: 'Repr',
          },
          resource: '/api/catalog/payers/',
        },

      },
      land_id: {
        type: 'field',
        required: false,
        read_only: false,
        label: 'land id',
      },

      isCalculate: {
        type: 'boolean',
        required: false,
        read_only: false,
        label: 'Розрахувати',
      },
      amount: {
        type: 'decimal',
        required: false,
        read_only: false,
        label: 'Значення',
      },
    },
  },
};

function LandsTablePart({
  data, onChange,
}) {
  const readOnly = false;
  const {
    displayedItems, fields, actions, permissions, activeRow,
    pages, currentPage, getControlTP,
  } = useTablePart({
    data, options, onChange, readOnly, defaultRecord,
  });
  return (
    <>
      <TPCommandPanel
        actions={actions}
        permissions={permissions}
        pages={pages}
        currentPage={currentPage}
        activeRow={activeRow}
      />
      <TableContainer component={Paper} sx={{ maxHeight: '60vh' }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>
                {fields.isCalculate.label}
              </TableCell>
              <TableCell>
                {fields.land.label}
              </TableCell>
              <TableCell>
                {fields.amount.label}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayedItems.map((row) => (
              <Row
                actions={actions}
                row={row}
                getControlTP={getControlTP}
                active={activeRow === row.id}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
}

LandsTablePart.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape({
  })).isRequired,
  options: PropTypes.shape({
    child: PropTypes.shape({
      children: PropTypes.shape(),
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default memo(LandsTablePart);
